module.exports = __webpack_public_path__ + "img/image-svg.d11fa0c7.png";